import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./TCPopUp.module.css";

import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { usePrivacy } from "PrivacyPage/usePrivacy";
import { useAccount } from "utils/AccountInfoContext";

import logo from "./wwg_logo.png";
import TermsAndConditions from "../components/TermsAndConditions";

import X from "./x.svg";
import DreambuildersIcon from "./Dreambuilders_Membership_Alert_Icon.svg";
import AgreeTerms from "./Agree_Terms.svg";
import HelpSupportIcon from "assets/help_support_icon.svg";

import mobile from "mobileBridge";

import environment from "environment";
import { NavigationSvc } from "../navigationScv";
import { useTranslation } from "react-i18next";

/**
 * Opens a pop up to agree to T&C
 */

export function TCPopUp() {
  const { t } = useTranslation();
  const history = useHistory();
  const navigationSvc = new NavigationSvc();

  const { tcAgreePost, setDirectToTCPage } = useAccount();
  // const { toggleAmway, toggleUpline } = usePrivacy(); // Import the toggle functions

  const handleAgree = async () => {
    try {
      // await toggleAmway.mutateAsync(); // Automatically check Amway
      // await toggleUpline.mutateAsync();
      await tcAgreePost.mutateAsync();
      setDirectToTCPage(false);
    } catch (error) {
      console.error("Error agreeing to T&C:", error);
    }

    let _prevUrl = document.referrer;

    if (
      _prevUrl &&
      !_prevUrl.includes("settings") &&
      !_prevUrl.includes("apps-dev.wwdb.com") &&
      !_prevUrl.includes("apps-staging.wwdb.com") &&
      !_prevUrl.includes("wwdb.com")
    ) {
      window.location.assign(_prevUrl);
    } else {
      history.push("/");
    }
  };

  const handleDisagree = () => {
    showError();
  };

  const [showDisagreeError, setShowDisagreeError] = useState(false);

  const showError = () => {
    setShowDisagreeError(true);
  };

  // prevent user from simply clicking back to avoid tc
  useEffect(() => {
    var hash = window.location.hash;
    setInterval(() => {
      if (window.location.hash != hash) {
        hash = window.location.hash;
      }
    }, 100);
  }, []);

  return (
    <>
      <div className={styles.container}>
        {showDisagreeError && (
          <div className={styles.disagreeErrorContainer}>
            <div className={styles.modalContainer}>
              <img
                className={styles.exitIcon}
                src={X}
                alt="exit alert"
                onClick={() => setShowDisagreeError(false)}
              />
              <div className={styles.modalContent}>
                <img
                  className={styles.dbIcon}
                  src={DreambuildersIcon}
                  alt="Dreambuilders Icon"
                />
                <div className={styles.modalContentHeader}>
                  {t("Dreambuilders Membership Terms & Condidtions")}
                </div>
                <div className={styles.modalContentText}>
                  {t("To proceed with using app and website")}
                </div>
                <div className={styles.modalContentText}>
                  {t("If you don't agree with terms & conditions")}
                </div>
              </div>
              <div className={styles.helpContainer}>
                <img
                  className={styles.agreeTermsBtn}
                  src={AgreeTerms}
                  alt="Agree Terms Button"
                  onClick={() => handleAgree()}
                />
                <div className={styles.supportContainer}>
                  <img
                    className={styles.helpIcon}
                    src={HelpSupportIcon}
                    alt="HelpIcon"
                    onClick={() => {
                      mobile.isApp()
                        ? navigationSvc.goToApp("help", {})
                        : window.open(environment.helpUrl, "_blank");
                    }}
                  />
                  {t("Contact Support")}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={styles.row}>
          <img src={logo} alt="WWG Logo" />
          <div className={styles.title}>{t("Update")}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.info}>
            {t("We have updates to Terms & Conditions")}
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.new}>{t("Here's what's new")}</div>
          <div className={styles.newList}>
            <ul>
              <li>{t("Complimentary Member Inactivity Status")}</li>
            </ul>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.tcContainer}>
            <div className={styles.tcContent}>
              <TermsAndConditions onYes={handleAgree} onBack={handleDisagree} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

TCPopUp.propTypes = {};
